import React from "react";
import { Modal } from "react-bootstrap";
import Colors from "../../stories/assets/Colors";
import classes from "./ModalSkeleton.module.css";
import { cancelIcon } from "../../constant/imagePath";

export default function ModalSkeleton({
  show,
  setShow,
  header,
  footer,
  children,
  modalClass,
  hideHeaderBorder,
  headerStyles,
  footerStyles,
  borderRadius,
  showCloseIcon,
  width,
  borderLine = true,
  headerClass,
}) {
  function handleClose() {
    setShow(false);
  }
  return (
    <>
      <style jsx>{`
        .modal-header {
          border-bottom: ${!borderLine && "none !important"};
          padding-bottom: ${!borderLine && "0 !important"};
        }
        .modal-header {
          border-bottom: ${hideHeaderBorder
            ? "none"
            : `1px solid ${Colors.neutralShadesOfGainsboro}`};
        }
        .modal-footer {
          margin: 0px;
          display: unset;
          justify-content: unset;
          align-items: unset;
          padding: ${!borderLine ? "15px 30px" : "0px"};
        }

        .${classes.header} button {
          color: ${Colors.neutralShadesOfNero} !important;
          background: url(${cancelIcon}) !important;
        }
        .modal-content {
          width: 100%;
          border-radius: ${borderRadius ? borderRadius : "0px"};
        }
        .modal .modal-dialog {
          max-width: ${width};
          margin: 0px auto;
        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className={`${[classes.modal].join(" ")}`}
      >
        {header && (
          <Modal.Header
            closeButton
            className={`${[classes.header, headerClass && headerClass].join(
              " "
            )}`}
            style={{ ...headerStyles }}
          >
            <div>{header}</div>
          </Modal.Header>
        )}
        {showCloseIcon && (
          <div className={classes.iconBox} onClick={handleClose}>
            <img src={cancelIcon} />
          </div>
        )}
        <Modal.Body
          className={`${[classes.body, modalClass && modalClass].join(" ")}`}
        >
          {children}
        </Modal.Body>
        {footer && (
          <Modal.Footer
            className={`${[classes.footer].join(" ")}`}
            style={{
              borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              ...footerStyles,
            }}
          >
            <div>{footer}</div>
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
